import React from 'react'

import { Col, Grid } from '../structure/Grid'
import { useCalendar } from './CalendarHandler'
import Placeholder from '../loader/Placeholder'

const HourlyPlaceholder = () => {
  const { loading } = useCalendar()
  if (!loading) return false

  return (
    <>
      <Grid gap={0.5} width="100%" marginTop={1}>
        <Col flex={1}>
          <Placeholder minHeight={1.5} radius={0.2} />
        </Col>
        <Col flex={1}>
          <Placeholder minHeight={1.5} radius={0.2} />
        </Col>
      </Grid>
    </>
  )
}

export default HourlyPlaceholder
